// extracted by mini-css-extract-plugin
module.exports = {"Spinner_root":"_29dj","Spinner":"Jc_9","SpinnerInner":"sTM3","clip-rotate":"uB31"};